import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export default function Length({
  value,
  onChange,
}: {
  value: string;
  onChange: (lengthRange: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select length" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="10 - 60 seconds">10 - 60 seconds</SelectItem>
        <SelectItem value="1 - 3 minutes">1 - 3 minutes</SelectItem>
        <SelectItem value="3 - 5 minutes">3 - 5 minutes</SelectItem>
        <SelectItem value="5 - 10 minutes">5 - 10 minutes</SelectItem>
        <SelectItem value="10 - 15 minutes">10 - 15 minutes</SelectItem>
        <SelectItem value="15 - 30 minutes">15 - 30 minutes</SelectItem>
        <SelectItem value="30+ minutes">30+ minutes</SelectItem>
      </SelectContent>
    </Select>
  );
}
